import React from 'react';
import { graphql } from 'gatsby';
import classnames from 'classnames';

import PancakeIntro from '../PancakeIntro';
import Pancake from './Pancake';
import Container from '../Container';
import Card from '../Card';
import Button from '../Button';
import SanityPortableText from '../SanityPortableText';

import './Cards.scss';

const CardsPancake = (props) => {
  const { title, text, cards, theme, className } = props;

  const numberOfCards = cards.length;

  return (
    <Pancake className={classnames('CardsPancake', className)} theme={theme}>
      <Container>
        {(title || text) && <PancakeIntro title={title} text={text} />}
        {cards.length > 0 && (
          <div
            className={classnames(
              'CardsGrid',
              numberOfCards > 5 && 'CardsGridThreeColumns'
            )}
          >
            {cards.map((card) => (
              <Card theme="Light">
                <Card.Title>{card.cardTitle}</Card.Title>
                <Card.Content>
                  <SanityPortableText blocks={card.cardText} />
                </Card.Content>
                {card.cardCallToAction && (
                  <Card.CTA>
                    <Button
                      className={`corporate-light full`}
                      to={card.cardCallToAction.url}
                    >
                      {card.cardCallToAction.label}
                    </Button>
                  </Card.CTA>
                )}
              </Card>
            ))}
          </div>
        )}
      </Container>
    </Pancake>
  );
};

export const query = graphql`
  fragment SanityPancakeCards on SanityCards {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    cards {
      cardTitle
      cardText: _rawCardText
      cardCallToAction {
        url
        label
      }
    }
    theme
  }
`;

export default CardsPancake;
